// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"c5148e21","931":"1c0b128d"}[chunkId] + ".chunk.js";
};